/** *************************************************************
 * Copyright (c) 2006 - 2021, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 07/12/2018
 *
 * @version 0.8
 * Revisions:
 * 07/12/2018 - BW - Initial Creation
 * 02/15/2019 - BW - Continued development
 * 03/04/2019 - BW - Continued development
 * 03/05/2019 - BW - Continued development
 * 03/06/2019 - BW - Continued development
 * 03/11/2019 - BW - Added: window.onstorage - for IE11 localStorage sync issue
 * 07/26/2021 - BW - Modified: Updated for V6
 *
 * Description/Purpose:
 * Session Time Out JS
 ************************************************************** */
import StackTraceError from "component/stack-trace-error/stack-trace-error";
import { CaseMenuCountUtil, COMMON_TAG_DATA } from "component/case-menu-count/case-menu-count-util";
import { PAGE_PARAM, TAG_DATA } from "constant/app-constant";
import AjaxUtil from "util/ajax-util";
import CommonUtil from "util/common-util";
import BasicAjaxResponseJSONDTO from "dto/basic-ajax-response-json-dto";
import CaseMenuCountJsonDto from "component/case-menu-count/case-menu-count-json-dto";
import { COMMON as COMMON_CASE_MENU_UTIL } from "util/case-menu-util";

const CaseMenuCount = {


  /**
     * Init
     * @returns {CaseMenuCount}
     */
  init() {
    this._setUpVariable();
    this._cacheDom();

    if (this._runCaseMenuCount) {
      // If we are on the Case Menu page, run immediately, otherwise run after a second (hover menu)
      CommonUtil.sleep(this._$caseMenuCaseDetail.length === 0 ? 1000 : 0)
        .then(() => {
          this.getCaseMenuCount();
        });
    }

    return this;
  },


  /**
     * Set up some common variables
     * @private
     */
  _setUpVariable() {
    return this;
  },


  /**
     * Caches some often used DOM objects
     * @returns {CaseMenuCount}
     * @private
     */
  _cacheDom() {
    try {
      this._$caseMenuCaseDetail = $(COMMON_CASE_MENU_UTIL.CASE_MENU_CASE_DETAIL_SELECTOR);
      this._runCaseMenuCount = COMMON_TAG_DATA.RUN_CASE_MENU_COUNT;
      this._eActCaseMenuCount = COMMON_TAG_DATA.E_ACT_CASE_MENU_COUNT;
    } catch (e) {
      StackTraceError.processError(e, 'Session Time Out - Cache Dom');
    }
    return this;
  },


  /**
     * Simply calls an Ajax call to get the Case Menu Counts
     * @param attempt - default 1 - the attempt number.  After 3 we throw an error message.
     */
  getCaseMenuCount(attempt = 1) {
    try {
      // Now get the data, render to the modal
      const dataAjax = `&${PAGE_PARAM.E_CASE_ID}=${TAG_DATA.E_CASE_ID}`;

      // Make ajax call
      const request = AjaxUtil.getJsonToApplicationServlet(
        this._eActCaseMenuCount, {}, dataAjax,
      );
      request.done((data) => {
        const basicAjaxResponseJSONDTO = new BasicAjaxResponseJSONDTO(data);
        const caseMenuCountJsonDto = new CaseMenuCountJsonDto(
          basicAjaxResponseJSONDTO.data,
        );
        CaseMenuCountUtil.processCaseMenuCounts(caseMenuCountJsonDto);
      });
      request.fail((jqXHR, textStatus, errorThrown) => {
        CommonUtil.failedAttemptRetry(() => this.getCaseMenuCount(attempt + 1),
          `Case Menu Count - Get Case Menu Count - Attempt[${attempt}]`, attempt, errorThrown, false);
      });
    } catch (e) {
      StackTraceError.processError(e, 'Get Case Menu Count');
    }
  },


};


export default CaseMenuCount;
